module.exports = __webpack_public_path__ + "img/map_caruaru.b224324d.png";